import Pill from './Pill';
import PlugIcon from './PlugIcon';

const EvCreditPill = () => {
  return (
    <Pill>
      <div
        data-qa="ev-credit-pill"
        className="flex flex-row gap-4 items-center"
      >
        <PlugIcon />
        EV Credit
      </div>
    </Pill>
  );
};

export default EvCreditPill;
